<template>
    <div class="cs4-cart-coupon-bar">
        <div class="cs4-cart-coupon">
            <div class="cs4-cart-couponError" v-if="isError"> <div class="cs4-cart-couponError__icon">!</div>{{ errorMessage }}</div>
            <div>
                <input type="text"  v-on:keyup.enter="applyCoupon" class="cs4-cart-coupon__field" :class="{'cs4-cart-coupon__field--error' : isError}" :placeholder="dictionary.doYouHaveACouponWriteItHere" v-model="couponValue"/>
            </div>
            
            <div class="cs4-cart-coupon__button" v-on:click="applyCoupon">{{dictionary.apply}}</div>
        </div>
        <div class="cs4-cart-coupon__applied">
            <CouponItem v-for="coupon in cart.coupons" :key="coupon.code" :couponName="coupon.code" @removeCoupon="removeCoupon(coupon.code)"></CouponItem>
        </div>
    </div>
</template>

<script>
import CouponItem from './CouponItem.vue';
const axios = require('axios').default;

export default{
    props: ['cart','nonce','dictionary'],
    emits: ['cartRefresh','toggleLoading'],
    data(){
        return {
          couponValue: '',
          isError: false,
          errorMessage: ''
        }
    },
    methods: {
        async applyCoupon(){
            this.$emit('toggleLoading');
            this.resetError();
            await axios.post('/wp-json/wc/store/cart/coupons/', {
                code: this.couponValue
            }, {
                headers: {
                    'Nonce': this.nonce
                }
            }
            ).then(() => {
                this.$emit('toggleLoading');
                this.$emit('cartRefresh');
                this.couponValue = '';
            }).catch(() => {
                this.$emit('toggleLoading');
                this.isError = true;
                this.errorMessage = this.dictionary.thePromotionalCodeIsNotValid;
            });
        },
        async removeCoupon(couponCode){
            this.$emit('toggleLoading');
            await axios.delete('/wp-json/wc/store/cart/coupons/' + couponCode, {
                headers: {
                    'Nonce': this.nonce
                }
            }
            ).then(() => {
            this.$emit('toggleLoading');
            this.$emit('cartRefresh');
            }).catch(() => {
            this.$emit('toggleLoading');
            });
        },
        resetError(){
            this.isError = false;
            this.errorMessage = '';
        }
    },
    components: {
        CouponItem
    }
}
</script>

<style lang="scss" scoped>
.cs4-cart-coupon {
    max-width: 100%;
    min-height: 55px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 25px;  
    display: grid;
    grid-template-columns: auto 100px;
    column-gap: 10px;
    margin: 15px 15px 0 15px;

    &Error{
        grid-column: 1 / span 2;
        background-color: #FB7283;
        border-radius: 10px;
        font-size: 15px;
        display: flex;
        align-items: center;
        margin: 15px 10px 5px;

        
        &__icon{
            width: 20px;
            height: 20px;
            display: block;
            background-color: #B81C23;
            padding: 3px;
            margin: 3px 10px 3px 5px;
            border-radius: 50%;
            color: white;
            font-weight: 800;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    &__button {
      grid-column: 2;
      background: #3887CF;
      margin: 10px 10px 10px 0;
      border-radius: 25px;
      font-size: 15px;
      font-weight: 300;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    &__field {
      width: calc(100% - 15px);
      background: white;
      border-radius: 25px;
      margin: 10px;
      border: none;
      font-size: 15px;
      font-weight: 400;
      color: #686868;
      font-family: 'Poppins', sans-serif;
      min-height: 35px;
      padding: 5px 15px;

      &:focus {
        outline: none;
      }

      &::placeholder {
        font-size: 12px;
        color: #A4A4A4;
        font-family: 'Poppins', sans-serif;
      }

      &--error {
        border: 2px solid #FB7283;
        color:#FB7283;
        &:focus {
            border-color: #FB7283;
        }
      }
    }

    &__applied {
      margin: 0 15px;
      display: flex;
      flex-wrap: wrap;
    }

    
  }
</style>